/**
 * Type definitions for credit system
 */

/**
 * Credit package for purchase
 */
export interface CreditPackage {
  /** Package identifier */
  id: string;
  /** Display name */
  name: string;
  /** Number of credits in package */
  credits: number;
  /** Display price string */
  priceDisplay: string;
  /** Whether this is the popular/recommended option */
  popular: boolean;
  /** Optional savings percentage display */
  savings?: string;
}

/**
 * Credit transaction record
 */
export interface CreditTransaction {
  /** Type of transaction */
  action: 'generate' | 'purchase';
  /** Amount of credits */
  amount: number;
  /** Timestamp of transaction */
  timestamp: number;
  /** Balance after transaction */
  balance: number;
}

/**
 * Credit balance response
 */
export interface CreditBalanceResponse {
  /** Current credit balance */
  credits: number;
}

/**
 * Use credit response
 */
export interface UseCreditResponse {
  /** Remaining credits after use */
  remainingCredits: number;
  /** Optional message */
  message?: string;
}

/**
 * Purchase credits response
 */
export interface PurchaseCreditsResponse {
  /** Stripe checkout URL */
  checkoutUrl: string;
  /** Session ID */
  sessionId?: string;
}

/**
 * Credit operation types
 */
export type CreditOperation = 'generate' | 'export' | 'share';

/**
 * Available credit packages
 */
export const CREDIT_PACKAGES: CreditPackage[] = [
  {
    id: 'starter',
    name: 'Starter Pack',
    credits: 10,
    priceDisplay: '$1.99',
    popular: false,
  },
  {
    id: 'creative',
    name: 'Creative Pack',
    credits: 50,
    priceDisplay: '$7.99',
    popular: true,
    savings: '20%',
  },
  {
    id: 'professional',
    name: 'Professional Pack',
    credits: 100,
    priceDisplay: '$12.99',
    popular: false,
    savings: '35%',
  },
];
